import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { responsiveStoreEnhancer } from 'redux-responsive';
import Raven from 'raven-js';
import createRavenMiddleware from 'raven-for-redux';
import createSagaMiddleware from 'redux-saga';
import reducer from '../reducers';
import SETTINGS from '../config';
import sagas from '../sagas/';

const sentryURL = SETTINGS.SENTRY_URL;

const sagaMiddleware = createSagaMiddleware();
let middleware;

if (process.env.NODE_ENV !== 'development') {
    Raven.config(sentryURL, {
        environment: process.env.NODE_ENV,
    }).install();
    const ravenMiddleware = createRavenMiddleware(Raven);
    middleware = [ravenMiddleware, sagaMiddleware];
} else {
    middleware = [sagaMiddleware];
}

export default function makeStore(initialState = {}) {
    const store = createStore(
        reducer,
        initialState,
        composeWithDevTools(responsiveStoreEnhancer, applyMiddleware(...middleware))
    );

    if (process.env.NODE_ENV === 'development') {
        Raven.setUserContext({
            email: SETTINGS.SENTRY_DEV_USER,
        });
    }

    sagaMiddleware.run(sagas);

    return store;
}



// WEBPACK FOOTER //
// ./src/store/Store.js